import { Icon, search, spinner } from '../../../components/Icon/Icon';
import { renderTemplate } from '../../../components/utils';
import { ProductSearchResults } from '../../../hooks/useAddProductSearch';
import { useTranslation } from '../../../i18n/i18n';
import './AddProductSearchForm.css';

export const AddProductSearchForm = ({
	query,
	setQuery,
	results,
}: {
	query: string;
	setQuery: (value: string) => void;
	results: ProductSearchResults;
}) => {
	const t = useTranslation().editOrder;

	return (
		<>
			<div className="add-product-search-form">
				<input
					placeholder={t.searchForProducts}
					type="text"
					value={query}
					onChange={(e) => setQuery(e.target.value)}
				></input>
				<div className="search-icon">
					<Icon shape={search} size={20} />
				</div>
				<div className="loading-icon">
					<Icon shape={spinner} size={20} />
				</div>
			</div>

			{results.showResults && (
				<h3>
					{renderTemplate(t.searchResults, {
						query: results.searchedQuery,
						total: results?.total,
					})}
				</h3>
			)}
		</>
	);
};
